module.exports = __webpack_public_path__ + "img/red.468306d2.png";